export default {
    computed: {
        getLanguage: {
            get: function() {
                return this.$store.getters.getLanguage;
            }
        },
        getLoading: {
            get: function() {
                return this.$store.getters.getLoading;
            }
        },
        getShoppingCart: {
            get: function() {
                return this.$store.getters.shoppingCart;
            }
        },
        shoppingCartCounter: {
            get: function() {
                return this.$store.getters.shoppingCartCounter;
            }
        },
        Contries: {
            get: function() {
                return this.$store.getters.Contries;
            }
        },
        Currencies: {
            get: function() {
                return this.$store.getters.Currencies;
            }
        },
        Banks: {
            get: function() {
                return this.$store.getters.Banks;
            }
        },
        SafetyPayBanks: {
            get: function() {
                return this.$store.getters.SafetyPayBanks;
            }
        },
        Amount: {
            get: function() {
                return this.$store.getters.Amount;
            }
        },
        IPAddress: {
            get: function() {
                return this.$store.getters.getIPAddress;
            }
        }
    }
};
